const convertStringToKebabCase = (string) => {
  if (typeof string !== 'string') return null;

  // Necessary to ignore accented characters
  const normalizedString = string
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();

  return Array.isArray(normalizedString
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) ?
    normalizedString
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map(x => x.toLowerCase())
      .join('-') :
    '';
};

export default convertStringToKebabCase;
